// extracted by mini-css-extract-plugin
export default {"form":"ExpenseForm_form__yB0TI","submit":"ExpenseForm_submit__O3JGh"};